function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M345.4 248.3L151.2 442.6c-12.4 12.4-32.4 12.4-44.8 0-12.4-12.4-12.4-32.4 0-44.7L278.3 226 106.4 54C94 41.6 94 21.6 106.4 9.3c12.4-12.4 32.4-12.4 44.8 0l194.3 194.3c6.2 6.2 9.3 14.3 9.3 22.4-.1 8-3.2 16.1-9.4 22.3z",
  fill: "#17143b"
});
function SvgArrowRight(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451.8 451.8",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
export default __webpack_public_path__ + "f0205ba2b4a10bcd69814a8418f5bf15.svg";
export { SvgArrowRight as ReactComponent };